export default __webpack_public_path__ + "static/media/gournay16.ade04dae.jpg";